module.exports = __webpack_public_path__ + "static/img/icon_signin_woman.4a037e7e.svg";